
    import {
        defineComponent, PropType, toRefs, computed, unref,
    } from 'vue';
    import { formatNumber, wordEnding } from '@ve/services/textModifiers';
    import {
        IReturnProductType,
    } from '@ve/pages/hotel/types';
    import useProduct from '@ve/pages/hotel/use/useProduct';
    import ButtonV from '@ve/components/button/desktop/Button.vue';
    import NightDifference from '@ve/components/nightDiffrence/NightDifference.vue';
    import HintTooltip from '@ve/components/hintTooltip/desktop/HintTooltip.vue';
    import useProducts from '@ve/pages/hotel/use/useProducts';
    import isHotelOffersProductsHasFreeTariff from './services/isHotelOffersProductsHasFreeTariff';
    import ProductPrepayment from '../hotelButtons/components/ProductPrepayment.vue';
    import TextIcon from '../hotelButtons/components/TextIcon.vue';

    export default defineComponent({
        components: {
            ButtonV,
            TextIcon,
            NightDifference,
            ProductPrepayment,
            HintTooltip,
        },
        props: {
            products: {
                type: Array as PropType<IReturnProductType[]>,
                default: [],
            },
        },
        setup(props, { emit }) {
            const { products } = toRefs(props);

            const { firstProduct, productTextByType } = useProduct(products);

            const operators = computed(() => {
                const productsWithoutFirst = unref(products).filter((_, index) => index !== 0);
                const takenOperatorIds = [unref(products)[0].operator.id];
                return productsWithoutFirst.reduce((acc, product) => {
                    if (takenOperatorIds.indexOf(product.operator.id) === -1) {
                        acc.push(product.operator.name);
                        takenOperatorIds.push(product.operator.id);
                    }
                    return acc;
                }, [] as string[]);
            });

            const operatorsText = computed(() => `и ${unref(operators).length} ${wordEnding(unref(operators).length, 'туроператор;туроператора;туроператоров')}`);

            const operatorsPopoverText = computed(() => `Туры от ${unref(operators).length} ${wordEnding(unref(operators).length, 'туроператора;туроператоров;туроператоров')}`);

            const clickProductHandler = () => {
                emit('clickAdditionalProduct', unref(products));
            };

            return {
                firstProduct,
                productTextByType,
                operatorsPopoverText,
                operatorsText,
                operators,
                clickProductHandler,
                formatNumber,
                isHotelOffersProductsHasFreeTariff,
                ...useProducts(products),
            };
        },
    });
